(() => {
  const SELECTOR = 'quote-slider';

  class QuoteSlider extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const init = () => {
        if (typeof window.Swiper === 'undefined') return;
        if (this._swiper) return;

        const root = this.querySelector('[data-quote-swiper]');
        const prev = this.querySelector('[data-quote-prev]');
        const next = this.querySelector('[data-quote-next]');
        if (!root) return;

        const loop = this.dataset.loop !== 'false';
        const speed = Number(this.dataset.speed || 500);

        this._swiper = new window.Swiper(root, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed,
          loop: loop && root.querySelectorAll('.swiper-slide').length > 1,
          allowTouchMove: true,
          navigation: {
            prevEl: prev,
            nextEl: next,
          },
          a11y: {
            enabled: true,
          },
        });
      };

      if (typeof window.Swiper !== 'undefined') {
        init();
        return;
      }

      this._onSwiperReady = () => init();
      document.addEventListener('quote-swiper:ready', this._onSwiperReady, { once: true });
    }

    disconnectedCallback() {
      if (this._onSwiperReady) {
        document.removeEventListener('quote-swiper:ready', this._onSwiperReady);
      }
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
      this._ready = false;
    }
  }

  if (!customElements.get(SELECTOR)) {
    customElements.define(SELECTOR, QuoteSlider);
  }

  const markReady = () => {
    document.dispatchEvent(new CustomEvent('quote-swiper:ready'));
  };

  if (typeof window.Swiper !== 'undefined') {
    markReady();
  } else {
    const existing = document.querySelector('script[data-quote-swiper-lib]');
    if (existing) {
      existing.addEventListener('load', markReady, { once: true });
    }
  }
})();
